import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";
import type { Pricing } from "common/types";

async function getPricingRequest(): Promise<Pricing[]> {
  return (await get("billing/pricing")).pricing;
}

export default function usePricing() {
  const { data: pricing, isLoading: isLoadingPricing } = useQuery({
    queryKey: ["pricing"],
    queryFn: getPricingRequest,
    refetchOnMount: false,
  });

  return { pricing, isLoadingPricing };
}
